import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FALLBACK = { name: "Shri Ji Clinic", address: "Guna, Madhya Pradesh", phone: "+91 76949 16555", email: "", footer_note: "This is a computer-generated receipt. Get well soon." };
let cache = null;

export const useClinic = () => {
  const [clinic, setClinic] = useState(cache || FALLBACK);
  useEffect(() => {
    if (cache) return;
    api.get("/public/clinic").then((r) => { cache = r.data; setClinic(r.data); }).catch(() => {});
  }, []);
  return clinic;
};

export const refreshClinicCache = (data) => { cache = data; };
export const telHref = (phone) => `tel:${(phone || "").replace(/[^0-9+]/g, "")}`;
